import { createElement } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import { ModalContainer } from "@/3514/components"
import { EModalId } from "@/3514/store/modal"

import { ReloadAppModalContainer as Container } from "./reload-app.modal.container"
import { withReloadAppModal } from "./reload-app.modal.guard"

const Modal: FC = (): ReactElement =>
    createElement(ModalContainer, { modalId: EModalId.ReloadApp, container: Container as LazyExoticComponent<FC> })

const GuardedModal: FC = withReloadAppModal(Modal)

export { GuardedModal as ReloadAppModal }
